import { render, staticRenderFns } from "./TrackingView.vue?vue&type=template&id=422f3408&scoped=true"
import script from "./TrackingView.vue?vue&type=script&lang=ts"
export * from "./TrackingView.vue?vue&type=script&lang=ts"
import style0 from "./TrackingView.vue?vue&type=style&index=0&id=422f3408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f3408",
  null
  
)

export default component.exports